<template>
    <div style="position: relative">
        <table class="control-table control-table--compact">
            <thead class="control-table__head">
                <tr class="control-table__row">
                    <th style="width: 40%" class="control-table__cell">User</th>
                    <th style="width: 40%" class="control-table__cell">Role</th>
                    <th class="control-table__cell"></th>
                </tr>
            </thead>
            <tbody class="control-table__body">
                <template v-if="workers.length">
                    <tr v-for="worker in workers" :key="worker.id" class="control-table__row">
                        <td class="control-table__cell">
                            {{ worker.user_id.full_name || worker.user_id.email }}
                        </td>
                        <td class="control-table__cell">
                            {{ worker.role.label }}
                        </td>
                        <td class="control-table__cell" style="text-align: right">
                            <OrderManageWorkersDelete
                                v-if="worker.can_delete && order.permissions.destroy_worker"
                                :order-id="order.id"
                                :worker="worker"
                                @remove="onWorkerRemove"
                            />
                        </td>
                    </tr>
                </template>
                <template v-if="!loading && !workers.length">
                    <tr class="control-table__row">
                        <td class="control-table__cell" colspan="3">No workers</td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import OrderManageWorkersDelete from './OrderManageWorkersDelete';

export default {
    name: 'OrderManageWorkersTable',
    components: {
        OrderManageWorkersDelete,
    },

    props: {
        order: {
            type: Object,
            default: () => ({}),
        },
        workers: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        onWorkerRemove(event) {
            this.$emit('workerRemove', event);
        },
    },
};
</script>
